import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule],
})
export class LanguageComponent {
  public lang = {
    fr: 'FR',
    'es-ES': 'ES',
    'de-DE': 'DE',
    en: 'EN',
  };
  public href = {
    'fr-FR': '../fr-FR/',
    'es-ES': '../es-ES/',
    'de-DE': '../de-DE/',
    'en-US': '../en-US/',
  };

  public langSelected = new FormControl(this.lang.fr);

  constructor() {}

  public goToPage(lang: string) {
    window.location.href = this.href[lang];
  }
}
